import { render, staticRenderFns } from "./ServicoListFiltroModalItemInputSubProdutos.vue?vue&type=template&id=22b855bc"
import script from "./ServicoListFiltroModalItemInputSubProdutos.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItemInputSubProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports